import CreateBlock from "../containers/CreateBlock";
import { Zone } from "../API";

function AddBlock({ zone }: { zone: Zone }) {
  const { zoneId } = zone;

  return (
    <div>
      <h1>Add Block</h1>
      <CreateBlock zoneId={zoneId} isCreate={true} />
    </div>
  );
}

export default AddBlock;
